import React from "react";
import img from "../../../../assets/img/Home/image.png";
import location from "../../../../assets/img/icons/location-bbold-green.svg";
import eye from "../../../../assets/img/admin/eye.svg";
import edit from "../../../../assets/img/admin/edit-2.svg";
import profile from "../../../../assets/img/Home/profile.png";
import { useNavigate } from "react-router-dom";
const ResidenceCard = ({ inforesidence }) => {
  const navigate = useNavigate()
  return (
    <div className="ResidenceCard cursor-pointer" onClick={()=>navigate(`/admin/place/${inforesidence.code}/${inforesidence.slug}/${inforesidence.id}`)}>
     {inforesidence.thumbnail !== null && <img src={inforesidence.thumbnail.path} className="ResidenceCard__thumbnail" />}
      <div className="ResidenceCard__loc flex gap-[6px]">
        <img src={location} />
        <p>{inforesidence.city}</p>
      </div>
      <div className="ResidenceCard__code">کد آگهی :{inforesidence.code}</div>
      <h5>{inforesidence.title}</h5>
      <div className="flex justify-between">
        <div>
          <p className="ResidenceCard__profile--role">{inforesidence.host.role} اقامتگاه</p>
          <p className="ResidenceCard__profile--fullname">{inforesidence.host.full_name}</p>
        </div>
        <img className="ResidenceCard__profile" src={inforesidence.host.avatar} />
      </div>
      <div className="flex justify-between">
        <div className="ResidenceCard__status">{inforesidence.status}</div>
        <div className="flex gap-[10px]">
          {" "}<button>
            <img src={edit} />
          </button>
          <button className="ResidenceCard__eye">
            <img src={eye} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResidenceCard;
